import { Toolbar } from "@mui/material"

export const NAVBAR_HEIGHT = { xs: 64, sm: 70 }

const NavbarOffset = () => <Toolbar sx={{ minHeight: NAVBAR_HEIGHT }} />

export default NavbarOffset
